<template>
  <a-spin :spinning="loading">

    <div class="news-list">
      <div class="search-line">
        <a-form-model
          ref="searchForm"
          :model="searchForm"
          :label-col="{ span: 8 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-row>
            <a-col :span="6">
              <a-form-model-item label="所属系统" class="form-item">
                <a-select
                  v-model="searchForm.plateformId"
                  placeholder="请选择所属系统"
                  style="width: 100%"
                  allow-clear
                  @change="handleSystemChange"
                >
                  <a-select-option v-for="item in systemOptions" :key="item.plateformId" :value="item.plateformId">
                    {{ item.plateformName }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>

            <a-col :span="6">
              <a-form-model-item label="所属模块" class="form-item">
                <a-select
                  v-model="searchForm.moduleId"
                  placeholder="请选择所属模块"
                  style="width: 100%"
                  :disabled="!searchForm.plateformId"
                  allow-clear
                  @change="handleModuleChange"
                >
                  <a-select-option v-for="item in moduleOptions" :key="item.id" :value="item.id">
                    {{ item.moduleName }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="6">
              <a-form-model-item label="所属标签" class="form-item">
                <a-cascader
                  v-model="searchForm.categoryPathList"
                  :options="tagOptions"
                  :field-names="{
                    label: 'name',
                    value: 'path',
                    children: 'children'
                  }"
                  :change-on-select="true"
                  placeholder="请选择标签路径"
                  style="width: 100%"
                  :disabled="!searchForm.plateformId||!searchForm.moduleId"
                  allow-clear
                />
              </a-form-model-item>
            </a-col>

            <a-col :span="6">
              <a-form-model-item label="内容状态" class="form-item">
                <a-select
                  v-model="searchForm.state"
                  placeholder="请选择状态"
                  style="width: 100%"
                  allow-clear
                >
                  <a-select-option :value="1">草稿</a-select-option>
                  <a-select-option :value="2">已发布</a-select-option>
                  <a-select-option :value="3">已撤回</a-select-option>
                  <a-select-option :value="4">待发布</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>

            <a-col :span="6">
              <a-form-model-item label="内容标题" class="form-item">
                <a-input
                  v-model="searchForm.title"
                  placeholder="请输入内容标题"
                  style="width: 100%"
                  allow-clear
                />
              </a-form-model-item>
            </a-col>

            <a-col :span="6">
              <a-form-model-item label="创建人" class="form-item">
                <a-input
                  v-model="searchForm.createBy"
                  placeholder="请输入创建人"
                  style="width: 100%"
                  allow-clear
                />
              </a-form-model-item>
            </a-col>

            <a-col :span="6">
              <a-form-model-item label="创建时间" class="form-item">
                <a-range-picker
                  v-model="searchForm.createDate"
                  style="width: 100%"
                  :show-time="{ format: 'HH:mm:ss' }"
                  format="YYYY-MM-DD HH:mm:ss"
                  valueFormat="YYYY-MM-DD HH:mm:ss"
                  allow-clear
                />
              </a-form-model-item>
            </a-col>

            <a-col :span="6">
              <a-form-model-item label="最近更新时间" class="form-item">
                <a-range-picker
                  v-model="searchForm.lastUpdateDate"
                  style="width: 100%"
                  :show-time="{ format: 'HH:mm:ss' }"
                  format="YYYY-MM-DD HH:mm:ss"
                  valueFormat="YYYY-MM-DD HH:mm:ss"
                  allow-clear
                />
              </a-form-model-item>
            </a-col>

            <a-col :span="24">
              <a-form-model-item class="form-item operation-item" :wrapper-col="{ span: 24 }">
                <template
                  v-for="(item, index) in actionBtns"
                >
                  <a-button :key="index" type="primary" @click="item.clickFn">{{ item.name }}</a-button>
                </template>
                <a-button style="margin-left: 8px;" @click="handleReset">重置</a-button>
                <a-button style="margin-left: 8px" type="primary" @click="handleSearch">查询</a-button>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
      <div class="news-list-content">
        <vxe-grid
          ref="xGrid"
          v-bind="gridOptions"
          :data="tableData"
          @page-change="handlePageChange"
        >
          <template #operate="{ row }">
            <a-space>
              <template   v-for="(item, index) in operationBtns">
                <a-button
                  :key="index"
                  type="link"
                  size="small"
                  v-if="(item.isShow&&item.isShow(row))"
                  @click="item.clickFn(row)"
                >
                  {{ item.name }}
                </a-button>
              </template>
              <!-- <a-button
                v-if="row.state === 1 || row.state === 3||  row.state === 4"
                type="link"
                size="small"
                @click="goPage(row, 1)"
              >
                编辑
              </a-button>
              <a-button
                type="link"
                size="small"
                @click="goPage(row, 2)"
              >
                查看
              </a-button>
              <a-button
                v-if="row.state === 1 || row.state === 3"
                type="link"
                size="small"
                @click="operateHandle(row, 2)"
              >
                发布
              </a-button>
              <a-button
                v-if="row.state === 2"
                type="link"
                size="small"
                @click="operateHandle(row, 3)"
              >
                撤回
              </a-button>
              <a-button
                v-if="row.state === 1 || row.state === 3||  row.state === 4"
                type="link"
                size="small"
                @click="handleDelete(row)"
              >
                删除
              </a-button> -->
            </a-space>
          </template>
        </vxe-grid>
      </div>
    </div>
  </a-spin>
</template>

<script>
import {
  operateStudyCenter,
  listPlateformInfo,
  listCategoryInfo,
  studentCenterPageList
} from '@/api/news'
import commonMethods from '@/common/commonMethods'
import { removeEmptyChildren } from '@/common/common.js'
import { getPageBtnsFn} from '@/common/common'
import {mapState} from 'vuex'
export default {
  name: 'NewsList',
  mixins: [commonMethods],
  data() {
    return {
      loading: false,
      gridOptions: {
        border: true,
        showOverflow: true,
        minHeight: 440,
        height: '100%',
        maxHeight: '100%',
        loading: false,
        size: 'mini',
        columnConfig: {
          resizable: true
        },
        pagerConfig: {
          pageSize: 20,
          pageSizes: [10, 20, 50, 100],
          total: 0,
          currentPage: 1,
          layouts: ['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']
        },
        columns: [
          { type: 'seq', width: 60, title: '序号' },
          { field: 'title', title: '内容标题', minWidth: 200, showOverflow: true },
          { field: 'plateformName', title: '所属系统', width: 120 },
          { field: 'moduleName', title: '所属模块', width: 120 },
          { field: 'developerCategoryNames', title: '所属标签', width: 120,
          formatter: ({ cellValue }) => {
           
              return cellValue.join('/')
            }
         },
          { field: 'createBy', title: '创建人', width: 100 },
          { field: 'createDate', title: '创建时间', width: 160 },
          {
            field: 'state',
            title: '内容状态',
            width: 100,
            formatter: ({ cellValue }) => {
              const stateMap = {
                1: '草稿',
                2: '已发布',
                3: '已撤回',
                4: '待发布'
              }
              return stateMap[cellValue] || cellValue
            }
          },
          { field: 'accessNum', title: '访问量', width: 100 },
          { field: 'lastUpdateBy', title: '更新人', width: 100 },
          { field: 'lastUpdateDate', title: '最近更新时间', width: 160 },
          { title: '操作', width: 220, fixed: 'right', slots: { default: 'operate' }}
        ]
      },
      tableData: [],
      searchForm: {
        plateformId: undefined,
        moduleId: undefined,
        state: undefined,
        title: '',
        createBy: '',
        createDate: [],
        lastUpdateDate: [],
        categoryPathList: []
      },
      systemOptions: [],
      moduleOptions: [],
      tagOptions: [],
      actionBtns:[],
      operationBtns:[]
    }
  },
  computed:{
    ...mapState('setting', ['isImplant']),

  },
  mounted() {
    this.init()
    this.loadSystemOptions()
    this.handleSearch()
  },
  methods: {
    init(){
      const actions = [
        {
          name: '新增',
          clickFn: ()=>{
            this.goPage(null, 3)
          },
        },
      ]
      const operations = [
        {
          name:'编辑',
          isShow: (row) => {
            return row.state === 1 || row.state === 3||  row.state === 4
          },
          clickFn:(row)=>{
            this.goPage(row, 1)
          }
        },
        {
          name: '查看',
          isShow: (row) => {
            return true
          },
          clickFn:(row)=>{
            this.goPage(row, 2)
          }
        },
        {
          name:'发布',
         
          isShow: (row) => {
            return row.state === 1 || row.state === 3
          },
          clickFn:(row)=>{
            this.operateHandle(row, 2)
          }
        },
        {
          name:'撤回',
          isShow: (row) => {
            return row.state === 2
          },
          clickFn:(row)=>{
            this.operateHandle(row, 3)
          }
        },
        {
          name:'删除',
          isShow: (row) => {
            return row.state === 1 || row.state === 3||  row.state === 4
          },
          clickFn:(row)=>{
            this.handleDelete(row)
          }
        },
      ]
      
      this.setActionBtnsFn(actions, operations)
    },
     /*设置按钮权限*/
     async setActionBtnsFn(actions, operations) {
      const allBtns = {
        pageBtns: actions,
        tableBtns: operations,
      }
      let metaObj = this.$route.meta
      if(this.isImplant&&sessionStorage.getItem('routerMate')){
        metaObj = JSON.parse(sessionStorage.getItem('routerMate'))
      }
      const res = await getPageBtnsFn(allBtns, metaObj)
      this.actionBtns = res.actionBtns
      this.operationBtns = res.operations
    },
    async handlePageChange({ currentPage, pageSize }) {
      this.gridOptions.pagerConfig.currentPage = currentPage
      this.gridOptions.pagerConfig.pageSize = pageSize
      await this.loadData()
    },
    goPage(row, type) {
      const query = { id: type }
      if (row?.id) {
        query.newsId = row.id
      }
      this.$router.push({
        path: 'newsDetail',
        query
      })
    },
    operateHandle(row, operateType) {
      this.$confirm({
        title: '确认提示',
        content: operateType === 2 ? '确定要发布该条内容吗？' : '确定要撤回该条内容吗？',
        onOk: async() => {
          try {
            await operateStudyCenter({
              id: row.id,
              operateType
            })
            this.$message.success('操作成功')
            this.handleSearch()
          } catch (error) {
            console.error(error)
          }
        }
      })
    },
    handleDelete(row) {
      this.$confirm({
        title: '确认提示',
        content: '确定要删除该条内容吗？',
        onOk: async() => {
          try {
            await operateStudyCenter({
              id: row.id,
              operateType: 4
            })
            this.$message.success('删除成功')
            this.handleSearch()
          } catch (error) {
            console.error(error)
          }
        }
      })
    },
    // 加载系统选项
    async loadSystemOptions() {
      try {
        const res = await listPlateformInfo()
        this.systemOptions = res.body || []
      } catch (error) {
        this.$message.error('加载系统选项失败')
      }
    },
    // 加载标签选项
    async loadTagOptions() {
      try {
        const res = await listCategoryInfo({
          moduleId: this.searchForm.moduleId,
          plateformId: this.searchForm.plateformId
        })
        this.tagOptions = removeEmptyChildren(res.body || [])
      } catch (error) {
        this.$message.error('加载标签选项失败')
      }
    },
    // 系统变更
    handleSystemChange() {
      this.searchForm.moduleId = undefined
      this.searchForm.categoryPathList = []
      this.moduleOptions = []
      this.tagOptions = []
      if (this.searchForm.plateformId) {
        const system = this.systemOptions.find(item => item.plateformId === this.searchForm.plateformId)
        if (system) {
          this.moduleOptions = system.studyModuleInfoList || []
        }
      }
    },
    // 模块变更
    handleModuleChange() {
      this.searchForm.categoryPathList = []
      this.tagOptions = []
      if (this.searchForm.moduleId) {
        this.loadTagOptions()
      }
    },
    async handleSearch() {
      this.gridOptions.pagerConfig.currentPage = 1
      await this.loadData()
    },
    async loadData() {
      this.gridOptions.loading = true
      try {
        const params = {
          ...this.searchForm,
          pageSize: this.gridOptions.pagerConfig.pageSize,
          pageNo: this.gridOptions.pagerConfig.currentPage,
          categoryPath: this.searchForm.categoryPathList.length > 0 ? this.searchForm.categoryPathList[this.searchForm.categoryPathList.length - 1] : '',
        }
        const res = await studentCenterPageList(params)
        if (res.head.retCode === '0000' && res.body) {
          this.tableData = res.body.data || []
          this.gridOptions.pagerConfig.total = res.body.totalRow || 0
        } else {
          res.body && this.$message.error(res.head.retDesc || '加载数据失败')
          this.tableData = []
          this.gridOptions.pagerConfig.total = 0
        }
      } catch (error) {
        console.error(error)
        this.$message.error('加载数据失败')
        this.tableData = []
        this.gridOptions.pagerConfig.total = 0
      } finally {
        this.gridOptions.loading = false
      }
    },
    // 重置搜索条件
    handleReset() {
      this.searchForm = {
        plateformId: undefined,
        moduleId: undefined,
        state: undefined,
        title: '',
        createBy: '',
        createDate: [],
        lastUpdateDate: [],
        categoryPathList: []
      }
      this.moduleOptions = []
      this.tagOptions = []
      this.handleSearch()
    }
  }
}
</script>

<style lang="less" scoped>
.news-list {
  min-height: calc(100vh - 97px);
  .search-line {
    background: #fff;
    margin-bottom: 8px;
    border-radius: 4px;
    padding: 16px 0 8px;
    .form-item {
      margin-bottom: 8px;
      width: 100%;
      :deep(.ant-form-item-label) {
        min-width: 80px;
      }
      :deep(.ant-form-item-control-wrapper) {
        max-width: calc(100% - 80px);
      }
      &.operation-item {
        :deep(.ant-form-item-control) {
          text-align: right;
        }
        :deep(.ant-form-item-control-wrapper) {
          max-width: 100%;
        }
      }
    }
  }
  .news-list-content {
    height: calc(100vh - 272px);
    padding-bottom: 20px;
  }

}
</style>
